import { render, staticRenderFns } from "./submit-cmp-extended.vue?vue&type=template&id=6c1e6314&scoped=true"
import script from "./submit-cmp-extended.vue?vue&type=script&lang=js"
export * from "./submit-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./submit-cmp-extended.vue?vue&type=style&index=0&id=6c1e6314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e6314",
  null
  
)

export default component.exports